import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, Link } from "react-router-dom";
import db from "../../firebase.config";
import {
  addDoc,
  getDocs,
  query,
  collection,
  where,
  limit,
  doc,
  getDoc,
} from "firebase/firestore";
import ModalSlideshow from "../../components/modalSlideshow";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import bedroomIcon from "../../assets/bedroom_icon.svg";
import roomIcon from "../../assets/room_icon.svg";
import surfaceIcon from "../../assets/surface_icon.svg";
import logo from "../../assets/logo.svg";
import {
  COLOR_BLACK,
  COLOR_BLUE,
  COLOR_GREY_CITY,
  COLOR_WHITE,
  COLOR_GREY_FORM,
  COLOR_GREEN,
} from "../../constants/colors";
import {
  GREEN_BOLD,
  GREEN_LIGHT,
  YELLOW_LIGHT,
  YELLOW_BOLD,
  YELLOW_BROWN,
  RED_LIGHT,
  RED_BOLD,
  PURPLE_LIGHT_ONE,
  PURPLE_LIGHT_TWO,
  PURPLE_LIGHT_THREE,
  PURPLE_LIGHT_FOUR,
  PURPLE_LIGHT_FIVE,
  PURPLE_LIGHT_SIX,
  PURPLE_LIGHT_SEVEN,
} from "../../constants/energyColros";
import { SEND_EMAIL_CONTACT_URL } from "../../constants/cloudFunctions";
import {
  ANNONCE_COLLECTION,
  TMP_REQUESTS_COLLECTION,
} from "../../constants/firestoreCollection";
import axios from "axios";
import { IAnnonceInterface } from "../../interfaces/annonce";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: ${COLOR_BLACK};
  margin-top: 25px;
  letter-spacing: normal;
  overflow: hidden;

  .disponible {
    margin-bottom: 16px;
    font-size: 18px;
  }
`;

const Back = styled(Link)`
  border: none;
  background: transparent;
  font-size: 13px;
  color: ${COLOR_GREY_CITY};
  font-size: 18px;
  text-decoration: none;
  margin-bottom: 29px;
`;

const AnnonceBlock = styled.div`
  display: flex;
  justify-content: space-between;

  .text-bold {
    font-size: 30px;
    font-weight: bold;
    line-height: 1.13;
  }

  .text-bold-secondary {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 25px;
  }

  @media screen and (max-width: 1300px) {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
`;

const Infos = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 65%;
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: 1300px) {
    width: 100%;
    margin-bottom: 3%;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  width: 33%;
  height: 100%;

  .title, .author {
    font-size: 30px;
    font-weight: bold;
    line-height: 1.13;
  }

  @media screen and (max-width: 1300px ) {
    width: 100%;
  }
`;

const InfosImages = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 250px;
  //grid-template-rows: auto;
  gap: 13px;

  margin-bottom: 22px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
    cursor: pointer;
  }

  .logo {
    width: 248px !important;
    height: 212px !important;
    object-fit: cover;
    border-radius: 16px;
    cursor: pointer;
  }

  .item-0 {
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
  }

  .item-1 {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: 3;
  }

  .item-2 {
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 2;
    grid-column-end: 3;
  }

  .print-more {
    position: relative;
    text-align: center;
    img {
      filter: blur(2px);
    }
  }

  .number-photos {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
    font-weight: bold;
    cursor: pointer;
  }

  @media screen and (max-width: 450px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

const Location = styled.div`
  display: flex;
  justify-content: start;
  align-items: cneter;
  color: ${COLOR_GREY_CITY};
  font-size: 26px;
  font-weight: 600;
  width: 100%;
  margin-bottom: 15px;

  .text {
    margin-left: 17px;
  }

  .icon {
    font-size: 26px;
  }

  .reference {
    margin-left: auto;
  }
`;

const FormArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 98%;
  margin-top: 72px;
  background-color: ${COLOR_WHITE};
  border-radius: 10px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  border: solid 2px rgba(168, 168, 168, 0.24);
  position: relative;
  z-index: 1;

  .text {
    align-self: start;
    margin-bottom: 46px;
  }

  .bold {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.42;
  }

  @media screen and (max-width: 1300px) {
    width: 70%;
  }

  @media screen and (max-width: 1040px) {
    width: 95%;
  }
`;

const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 78px;
  width: 70%;

  img {
    width: 92px;
    height: 92px;
    border-radius: 100%;
    position: absolute;
    top: -36px;
  }

  .phone {
    background-color: ${COLOR_GREEN};
    border-radius: 10px;
    width: 100%;
    height: 49px;
    margin-top: 22px;
    border: none;
    text-align: center;
  }

  .phone-text {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    font-weight: bold;
    color: ${COLOR_WHITE};
    line-height: 1;
  }
`;

const FormInputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  margin-top: 66px;
  margin-bottom: 43px;
  font-family: sans-serif;

  label {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    line-height: 1.7;
    align-items: start;
    justify-content: center;
    margin-bottom: 32px;
    width: 100%;
    font-family: sans-serif;
  }

  input {
    border-radius: 10px;
    border: 2px solid ${COLOR_GREY_FORM};
    padding: 16px 20px;
    font-size: 20px;
    line-height: 1.7px;
    margin-top: 12px;
    width: 300px;
    font-family: sans-serif;
  }

  *::placeholder {
    color: ${COLOR_GREY_CITY};
    font-family: sans-serif;
  }

  .write-us {
    align-self: start;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.42;
    font-family: sans-serif;
  }

  .sending-button {
    width: 140px;
    height: 49px;
    border-radius: 10px;
    background-color: ${COLOR_GREEN};
    color: ${COLOR_WHITE};
    font-weight: bold;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .sending-button:hover {
    cursor: pointer;
  }

  textarea {
    width: 300px;
    height: 250px;
    border-radius: 10px;
    border: 2px solid ${COLOR_GREY_FORM};
    padding: 16px 20px;
    font-size: 20px;
    margin-top: 12px;
    resize: none;
  }

  .form-submitted {
    text-align: center;
  }

  @media screen and (max-width: 1300px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: auto;
  }
`;

const GlobalDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 30px;
  font-weight: bold;
  width: 100%;

  .title {
    margin-bottom: 18px;
    color: ${COLOR_BLACK};
  }

  .price {
    color: ${COLOR_BLUE};
  }

  .surface {
    font-size: 20px;
    font-weight: 600;
    color: ${COLOR_GREY_CITY};
  }
`;

const IconDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 18px;

  .info {
    display: flex;
    align-items: center;
  }

  .info:first-child {
    margin-right: 34px;
  }

  .info:last-child {
    margin-left: 34px;
    margin-right: 40px;
  }

  .icon-bubble {
    display: flex;
    align-items: center;
    margin: 0 14px 0 0;
    width: 44px;
    height: 44px;
    border-radius: 7px;
    background-color: #e0e0e0;
  }

  img {
    margin: 0 auto;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .info:first-child {
      margin: 4px 0;
    }

    .info:last-child {
      margin: 4px 0;
    }
  }
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px 0;
  width: 100%;

  .text-bold {
    margin-bottom: 35px;
  }

  .text {
    font-size: 22px;
    line-height: 1.45;
  }
`;

const Energy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 35px;
  width: 100%;

  .text-bold {
    margin-bottom: 23px;
  }

  .diagram {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 35px;
  }

  .energy-diagram {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .energy-item {
    padding: 15px 20px;
    border: none;
    color: ${COLOR_WHITE};
    font-weight: bold;
  }

  .selected {
    border: 4px solid ${COLOR_BLACK};
    border-box: box-sizing;
    border-radius: 7px;
  }

  .energy-item:first-child {
    border-radius: 10px 0 0 10px;
  }

  .energy-item:last-child {
    border-radius: 0 10px 10px 0;
  }

  .dpe-text {
    line-height: 1.45;
  }

  @media screen and (max-width: 800px) {
    .diagram {
      display: flex;
      flex-direction: column;
    }
  }
`;

const Consumption = styled.div`
  display: flex;
  flex-direction: column;

  .item_0 {
    background-color: ${GREEN_BOLD};
  }
  .item_1 {
    background-color: ${GREEN_LIGHT};
  }
  .item_2 {
    background-color: ${YELLOW_LIGHT};
  }
  .item_3 {
    background-color: ${YELLOW_BOLD};
  }
  .item_4 {
    background-color: ${YELLOW_BROWN};
  }
  .item_5 {
    background-color: ${RED_LIGHT};
  }
  .item_6 {
    background-color: ${RED_BOLD};
  }
`;

const Other = styled.div`
  margin-bottom: 16px;
`;

const GasEmission = styled.div`
  display: flex;
  flex-direction: column;

  .item_0 {
    background-color: ${PURPLE_LIGHT_ONE};
  }
  .item_1 {
    background-color: ${PURPLE_LIGHT_TWO};
  }
  .item_2 {
    background-color: ${PURPLE_LIGHT_THREE};
  }
  .item_3 {
    background-color: ${PURPLE_LIGHT_FOUR};
  }
  .item_4 {
    background-color: ${PURPLE_LIGHT_FIVE};
  }
  .item_5 {
    background-color: ${PURPLE_LIGHT_SIX};
  }
  .item_6 {
    background-color: ${PURPLE_LIGHT_SEVEN};
  }
`;

const LocationMap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .text {
    font-size: 20px;
    color: ${COLOR_GREY_CITY};
    font-weight: 600;
    line-height: 0.9;
  }

  .map {
    margin-top: 35px;
  }
`;

const alphabetToG: string[] = ["A", "B", "C", "D", "E", "F", "G"];

const PrintEnergyLevel = (level: string | undefined) => {
  return (
    <div className="energy-diagram">
      {alphabetToG.map((alphabet) => {
        return (
          <div
            className={
              alphabet === level
                ? "energy-item selected item_" + alphabetToG.indexOf(alphabet)
                : "energy-item item_" + alphabetToG.indexOf(alphabet)
            }
            key={alphabet}
          >
            {alphabet}
          </div>
        );
      })}
    </div>
  );
};

const getAnnounce = async (
  annonceId: string | undefined,
  _setItem: Dispatch<SetStateAction<IAnnonceInterface | undefined>>,
  images: string[],
  _setImages: Dispatch<SetStateAction<string[]>>
) => {
  const docRef = doc(db, ANNONCE_COLLECTION, annonceId + "");
  const snap = await getDoc(docRef);
  const data = snap.data();

  _setImages([]);
  _setItem(undefined);
  if (data) {
    const mainImage =
      data.mainImage && data.mainImage !== "null" ? data.mainImage : logo;
    const images = data.images && data.images !== "null" ? data.image : [];
    const honorairesLocataire = data.honorairesLocataire && data.honorairesLocataire !== "null" ? data.honorairesLocataire : null;
    const globalInfos =
      data.type +
      " " +
      (data.type !== "Parking"
        ? data.rooms +
          (data.rooms > 2 ? " pièces de " : " pièce de ") +
          data.surface +
          "m²"
        : "") +
      " à " +
      data.city;
    const dateRendered =
      data.date && data.date !== "null"
        ? data.date
        : null;
    const meuble = data.meuble === "true" ? true : false;
    let date = dateRendered ? dateRendered : null;
    if (date) {
      const splitDate = date.split("/");
      if (splitDate.length === 3) {
        date = new Date(splitDate[2], +splitDate[1] - 1, splitDate[0]);
      } else {
        const splitDateDot = date.split("-");
        if (splitDateDot.length === 3) {
          date = new Date(
            splitDateDot[2],
            +splitDateDot[1] - 1,
            splitDateDot[0]
          );
        }
      }
    }

    _setItem({
      address: data.address,
      meuble,
      author: data.author,
      bedrooms: data.bedrooms,
      city: data.city,
      consumption: data.consumption,
      date,
      dateRendered,
      description: data.description,
      gasEmission: data.gasEmission,
      globalInfos,
      phone: data.phone,
      postcode: data.postcode,
      price: data.price,
      reference: data.reference,
      rooms: data.rooms,
      surface: data.surface,
      mainImage,
      images,
      type: data.type,
      montantEtatDesLieux:
        data.montantEtatDesLieux && data.montantEtatDesLieux !== "null"
          ? data.montantEtatDesLieux
          : null,
      honorairesLocataire,
    });
    _setImages((images) => [mainImage, ...images]);
  } else {
    alert("Cette annonce n'est plus disponible !");
    window.location.replace("/location-vente");
  }
  return null;
};

const Annonce = () => {
  const [item, _setItem] = useState<IAnnonceInterface>();
  const [printNumber, _setPrintNumber] = useState<boolean>(false);
  const { annonceUrl } = useParams();
  const [openModal, _setOpenModal] = useState<boolean>(false);
  const [imageClikedId, _setImageClickedId] = useState<number>(0);
  const [messageSent, _setMessageSent] = useState<boolean>(false);
  const [images, _setImages] = useState<string[]>([]);

  let phone: string | undefined = "";

  useEffect(() => {
    // scroll to the top
    window.scrollTo(0, 0);
    getAnnounce(annonceUrl, _setItem, images, _setImages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // set the title of the page 
  useEffect(() => {
    document.title = "Annonce | " + item?.globalInfos;
  }, [item])

  phone = item?.phone
    .replace(/\s/g, "")
    .match(/.{1,2}/g)
    ?.join(" "); // Write phone number in the format: XX XX XX XX XX

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const lastname = e.target.lastname.value;
    const firstname = e.target.firstname.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const message = e.target.message.value;
    const now = new Date().toLocaleDateString("fr");

    const usersRef = query(
      collection(db, TMP_REQUESTS_COLLECTION),
      where("email", "==", email),
      where("annonceUrl", "==", annonceUrl),
      limit(1)
    ); // query docuemnts in "Request" collection which contains a "email" and "annonceUrl" keys with values equal to email and annonceUrl
    const usersSnap = await getDocs(usersRef); // gets a list of document corresponding to the query

    // Check if a request with the given email already exists
    //    If yes, do not add the request and send an alert to inform the user
    //    If not, add the request
    if (usersSnap.size === 0) {
      await addDoc(collection(db, TMP_REQUESTS_COLLECTION), {
        lastname: lastname,
        firstname: firstname,
        email: email,
        phone: phone,
        annonceUrl: annonceUrl,
        message: message,
        date: now,
      });

      axios
        .post(
          SEND_EMAIL_CONTACT_URL +
            `?lastname=${lastname}&firstname=${firstname}&email=${email}&phone=${phone}&message=${message}&url=${annonceUrl}`
        )
        .then((response) => console.log("response:", response.data))
        .catch((err) => console.log("error:", err));
      _setMessageSent(true);
    } else {
      alert(
        "Un message de votre part pour cette annonce est déjà en cours de traitement. Nous reviendrons vers vous dans les plus bref délais"
      );
    }
  };

  let infoImageProp: string | undefined =
    item?.images && (item?.images.length > 2 ? "" : "");
  let i = 0;

  return (
    <Wrapper>
      {openModal && images.length && (
        <ModalSlideshow
          images={images}
          index={imageClikedId}
          _setOpenModal={_setOpenModal}
        />
      )}
      <Back to={"/location-vente"}>&lt; Retour aux résultats</Back>
      <AnnonceBlock>
        <Infos>
          <InfosImages itemProp={infoImageProp}>
            {
              //images.length === 0 && <div>No images</div> ||
              images.slice(0, 3).map((image, index) => {
                i++;
                if (i === 3 && images.length > 3) {
                  return (
                    <span
                      className="print-more"
                      key={index}
                      onClick={() => {
                        _setOpenModal(true);
                        _setImageClickedId(images.indexOf(image));
                      }}
                    >
                      <img
                        src={image}
                        className={"item-" + images.indexOf(image).toString()}
                        alt="house_pics"
                      />
                      <div className="number-photos">
                        {" "}
                        + {images.length - 3}
                      </div>
                    </span>
                  );
                } else {
                  return (
                    <img
                      src={image}
                      className={
                        image === logo
                          ? "logo"
                          : "item-" + images.indexOf(image).toString()
                      }
                      key={index}
                      alt="house_pics"
                      onClick={() => {
                        _setOpenModal(true);
                        _setImageClickedId(images.indexOf(image));
                      }}
                    />
                  );
                }
              })
            }
          </InfosImages>
          <Location>
            <LocationOnOutlinedIcon className="icon" />
            <span className="text">
              {item?.city} {item?.postcode === "null" ? "" : item?.postcode}
            </span>
            <div className="reference">Réf: {item?.reference}</div>
          </Location>
          <GlobalDescription>
            <div className="title">
              {item?.globalInfos}{" "}
              {item?.postcode === "null" ? "" : item?.postcode}
            </div>
            <div className="price">{item?.price} €</div>
            <IconDescription>
              {item?.surface !== "null" && (
                <div className="info">
                  <span className="icon-bubble">
                    <img src={surfaceIcon} alt="surface" />
                  </span>
                  {item?.surface} m²
                </div>
              )}
              {item?.rooms !== "null" && (
                <div className="info">
                  <span className="icon-bubble">
                    <img src={roomIcon} alt="surface" />
                  </span>
                  {item?.rooms} pièces
                </div>
              )}
              {item?.bedrooms !== "null" && (
                <div className="info">
                  <span className="icon-bubble">
                    <img src={bedroomIcon} alt="surface" />
                  </span>
                  {item?.bedrooms} chambre(s)
                </div>
              )}
            </IconDescription>
          </GlobalDescription>
          <Description>
            <div className="text-bold">
              À propos de cet {item?.globalInfos.toLocaleLowerCase()}
              {item?.postcode === "null" ? "" : item?.postcode}
            </div>
            {item?.dateRendered && (<div className="disponible">Disponible le {item?.dateRendered}</div>)}
            <div className="disponible">Est meublé : {item?.meuble ? 'Oui' : 'Non'}</div>
            <div className="text" dangerouslySetInnerHTML={{__html: item?.description || ''}}></div>
          </Description>
          <Energy>
            <div className="text-bold">Bilan énergétique</div>
            <div className="diagram">
              <Consumption>
                <>
                  <div className="text-bold-secondary">
                    Classe energie
                  </div>
                  {PrintEnergyLevel(item?.consumption)}
                </>
              </Consumption>
              <GasEmission>
                <div className="text-bold-secondary">
                  Classe climat
                </div>
                {PrintEnergyLevel(item?.gasEmission)}
              </GasEmission>
            </div>
            <div className="dpe-text">
              DPE ancienne version réalisé selon une méthode qui ne garantit pas
              la même fiabilité que celle en vigueur depuis le 01/07/2021.
              Montant estimé des dépenses annuelles d’énergie pour un usage
              standard (année de référence 2015)
            </div>
          </Energy>
          <Other>
            {item?.honorairesLocataire && (
              <p>
                Honoraires de recherche Locataire : {item.honorairesLocataire}
              </p>
            )}
            {item?.montantEtatDesLieux && (
              <p>Montant de l'état des lieux : {item.montantEtatDesLieux}€</p>
            )}
          </Other>
          <LocationMap>
            <div className="text-bold">Où est situé ce bien ?</div>
            <div className="text">
              Cet appartement à {item?.city} ({item?.postcode})
            </div>
            <div className="map">
              <iframe
                width="900"
                height="450"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen={true}
                title="Gmaps iframe"
                src={
                  "//maps.google.com/maps?q=" +
                  item?.address +
                  item?.postcode +
                  item?.city +
                  "&z=15&output=embed"
                }
              />
            </div>
          </LocationMap>
        </Infos>
        <Contact>
          <div className="title">Cette annonce est présentée par</div>
          <FormArea>
            <FormHeader>
              <div className="author">{item?.author}</div>
              <div className="phone">
                {
                  <div
                    className="phone-text"
                    onClick={() => _setPrintNumber(!printNumber)}
                  >
                    {(printNumber && phone) ||
                      (!printNumber && <>Afficher le numéro de téléphone</>)}
                  </div>
                }
              </div>
            </FormHeader>
            <FormInputs>
              {(messageSent && (
                <span className="form-submitted">
                  <DoneOutlineIcon />
                  <div>Votre message a bien été envoyé</div>
                </span>
              )) || (
                <form onSubmit={handleSubmit}>
                  <label className="write-us">Ecrivez nous !</label>
                  <label htmlFor="firstname">
                    PRENOM*
                    <input
                      type="text"
                      id="firstname"
                      name="firstame"
                      placeholder="Prénom..."
                      required
                    />
                  </label>
                  <label htmlFor="lastname">
                    NOM*
                    <input
                      type="text"
                      id="lastname"
                      name="lastname"
                      placeholder="Nom..."
                      required
                    />
                  </label>
                  <label htmlFor="email">
                    EMAIL*
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Email..."
                      required
                    />
                  </label>
                  <label htmlFor="phone">
                    TÉLÉPHONE*
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      placeholder="Numéro de téléphone..."
                      required
                    />
                  </label>
                  <label htmlFor="message">
                    VOTRE MESSAGE*
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Message..."
                      required
                    />
                  </label>
                  <p className="text">* Champs requis</p>
                  <input
                    type="submit"
                    value="Envoyer"
                    className="sending-button"
                  />
                </form>
              )}
            </FormInputs>
          </FormArea>
        </Contact>
      </AnnonceBlock>
    </Wrapper>
  );
};

export default Annonce;
